import { render, staticRenderFns } from "./blackRangeList.vue?vue&type=template&id=4c2121f7&"
import script from "./blackRangeList.vue?vue&type=script&lang=js&"
export * from "./blackRangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports